import FeatureCard, {
  type FeatureCardProps,
  type FeatureCardVariant,
} from "./featureCard";
import FeatureItem, {
  type FeatureItemProps,
  type FeatureItemVariant,
} from "./featureItem";

export type FeatureElementLiteralProps = {
  element: JSX.Element;
};

// generic Feature Card/Item types
export type FeatureElementVariant =
  | FeatureCardVariant
  | FeatureItemVariant
  | "element";
// export type FeatureElementVariant = FeatureCardVariant | "element";

export type FeatureElementProps<Variant extends FeatureElementVariant> =
  Variant extends FeatureCardVariant
    ? FeatureCardProps
    : Variant extends "element"
      ? FeatureElementLiteralProps
      : FeatureItemProps;

export default function FeatureElement<Variant extends FeatureElementVariant>(
  props: FeatureElementProps<Variant> & { variant: FeatureElementVariant },
) {
  return ["large-image", "large-image-contain"].includes(props.variant) ? (
    <FeatureCard
      {...(props as FeatureCardProps & { variant: FeatureCardVariant })}
    />
  ) : props.variant === "element" ? (
    (props as FeatureElementLiteralProps).element
  ) : (
    <FeatureItem
      {...(props as FeatureItemProps & { variant: FeatureItemVariant })}
    />
  );
}
